import React from 'react';
import { observer } from 'mobx-react-lite';
import { viewStore } from '../../../../../stores/ViewStore';
import { ReactComponent as Chevron } from '../../../../../assets/icons/chevron.svg';
import { ReactComponent as Tick } from '../../../../../assets/icons/tick.svg';
import styles from './ViewToggle.module.scss';
import { useResultListContext } from 'common/contexts/ResultListContext';
import { screenStore } from 'stores/ScreenStore';
import {addGTMEvent} from "../../../../../helpers/analytics";

const ViewToggle: React.FC = () => {
  const {isTablet} = screenStore;

  const options = [
    {name: 'Relevance', requestValue: '', titleValue: 'Relevance', id: 0},
    {name: 'Price: From High to Low', requestValue: 'desc', titleValue: isTablet ? 'HI-LO' : 'Price: From High to Low', id: 1},
    {name: 'Price: From Low to High', requestValue: 'asc', titleValue: isTablet ? 'LO-HI' : 'Price: From Low to High', id: 2}
  ]

  const { sortBy, setSortBy } = useResultListContext();
  const [showSortOptions, setShowSortOptions] = React.useState(false);

  const currentSort = options.find(el => el.requestValue == sortBy)?.titleValue;

  const { view, setView } = viewStore;
  const toggleView = () => {
    const targetView = view == 'map' ? 'list' : 'map';
    setView(targetView);
    if(targetView == 'map'){
      addGTMEvent('listings_change_view_map', {  'listings_view_type' : viewParam });
    } else {
      addGTMEvent('listings_change_view_hide_map', {  'listings_view_type' : viewParam });
    }
  }
  const handleBackgroundClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setShowSortOptions(false);
    addGTMEvent('sort_menu_close', {  'listings_view_type' : viewParam });
  };
  const handleFilterChange = (id: number) => {
    setSortBy(options[id].requestValue);
    addGTMEvent('sort_menu_apply', {  'listings_view_type' : viewParam, sort_by_type: options[id].name });
  }
  const viewParam = new URLSearchParams(window.location.search).get('view');
  return (
    <div className={styles.container}>
      <span>Sort By</span>
      <div className={styles.content} onClick={
        () => {
          setShowSortOptions((prev) => !prev);
          if(showSortOptions){
            addGTMEvent('sort_menu_close', {  'listings_view_type' : viewParam });
          } else {
            addGTMEvent('sort_menu_open', {  'listings_view_type' : viewParam });
          }

        }
      } style={{borderColor: showSortOptions ? '#00927c' : ''}}>
        {currentSort}
        <Chevron style={{ transform: showSortOptions ? 'rotate(180deg)' : 'none' }} />
        {showSortOptions && (
          <>
            <div className={styles.background} onClick={handleBackgroundClick}>
            </div>
            <div className={styles.options}
            //  style={{ top: view === 'map' &&  isTablet ? '56px' : ''}}
            >
              {options.map(({name, titleValue, id}) => {
                return (
                  <div className={titleValue == currentSort ? styles.option_active : styles.option} onClick={() => handleFilterChange(id)}>{name}
                    {titleValue == currentSort && <Tick style={{color: '#00C78B', width: '16px', marginBottom: '0'}}/>}
                  </div>
                )
              })}
            </div>
          </>
        )}
      </div>
      <div onClick={toggleView}>
        {view == 'map' ? 'Hide' : 'Show'} Map
      </div>
    </div>
  );
};

export default observer(ViewToggle);
